import React from 'react';
import './Configurations.css';
import SidePanel from './SidePanel';
import MainPanel from './MainPanel'; 

const Configurations = ({ user }) => {
  return (
    <div className="config-wrapper">
      <SidePanel />
      <MainPanel user={user} /> 
    </div>
  );
};

export default Configurations;
